// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lZGO","title":"styles_title__1lnSa"};